import { render, staticRenderFns } from "./BillingAddTPAMoal.vue?vue&type=template&id=17ad7918&scoped=true"
import script from "./BillingAddTPAMoal.vue?vue&type=script&lang=js"
export * from "./BillingAddTPAMoal.vue?vue&type=script&lang=js"
import style0 from "./BillingAddTPAMoal.vue?vue&type=style&index=0&id=17ad7918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad7918",
  null
  
)

export default component.exports